<template>
  <!-- Figma: row p-8 gap-8、サムネ 72x72、タイトル p1 17/24 (1 行・ellipsis)、
       meta は p2 16/24 と p3 14/20 のベースライン揃え、区切りは "|" 12/16 fg.muted -->
  <NuxtLink class="flex items-center gap-2 rounded-[2px] p-2 hover:bg-black/5" :to="location" @click="props.onClick">
    <OptimizedImage
      loading="lazy"
      :alt="hit.experience.name"
      :class="['size-[72px] shrink-0 rounded-[2px] object-cover']"
      :image-url="hit.experience.thumbnailUrl"
      :optimized-image-options="{ width: 240 }"
    />
    <div class="flex flex-1 flex-col justify-center overflow-hidden font-Spectral">
      <p class="truncate text-[17px] leading-6 text-gray4">{{ hit.experience.name }}</p>
      <p class="flex flex-wrap items-center gap-x-1 text-gray4">
        <span class="text-[16px] leading-6">{{ hit.experience.location }}</span>
        <span aria-hidden="true" class="text-[12px] leading-4">|</span>
        <span class="flex items-baseline">
          <img alt="" class="size-4 shrink-0 self-center" src="@/assets/icon/wabunka/schedule.svg" />
          <span class="text-[16px] leading-6">{{ hit.experience.durationMinutes }}</span>
          <span class="text-[14px] leading-5">min</span>
        </span>
        <template v-if="price">
          <span aria-hidden="true" class="text-[12px] leading-4">|</span>
          <span v-if="price.kind === 'private'" class="text-[14px] leading-5">Price upon request</span>
          <span v-else class="flex items-baseline">
            <span class="text-[14px] leading-5">from {{ priceSymbol }}</span>
            <span class="text-[16px] leading-6">{{ formattedAmount }}</span>
            <span class="text-[14px] leading-5">/person</span>
          </span>
        </template>
      </p>
    </div>
  </NuxtLink>
</template>

<script setup lang="ts">
import { OptimizedImage } from '@/wabunka-src/common/components';
import { CURRENCY_SYMBOLS } from '@/wabunka-src/common/utils/currency';
import type { AlgoliaExperienceHit } from '@/wabunka-src/features/Search/models/algoliaHit';
import { buildExperienceLocation } from '@/wabunka-src/features/Search/models/algoliaHitLink';
import type { ExperienceDisplayPrice } from '@/wabunka-src/features/Search/models/experienceDisplayPrice';

interface Props {
  hit: AlgoliaExperienceHit;
  onClick?: () => void;
  // 公開 API の参考価格。未指定（取得中・失敗・参考価格なし）なら価格欄を出さない。Algolia の price は使わない。
  price?: ExperienceDisplayPrice;
}

const props = defineProps<Props>();

const location = computed(() => buildExperienceLocation(props.hit));

const priceSymbol = computed(() => (props.price?.kind === 'priced' ? (CURRENCY_SYMBOLS[props.price.currency] ?? '') : ''));
const formattedAmount = computed(() => (props.price?.kind === 'priced' ? Math.round(props.price.amount).toLocaleString('en-US') : ''));
</script>
